import PropTypes from 'prop-types';
import classes from './head.module.css';

const Head = (props) => {
  const {
    title,
  } = props;

  return (title)
    ? (
      <div className={classes.head}>
        <h1 data-f="pageTitle" dangerouslySetInnerHTML={{ __html: title }} />
      </div>
    )
    : null;
};

Head.propTypes = {
  title: PropTypes.string,
};

export default Head;
